import {Inject, Pipe, PipeTransform} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';

@Pipe({
  standalone: false,
  name: 'bringozDimensions'
})
export class BringozDimensionsPipe implements PipeTransform {
  constructor(@Inject(TranslateService) private translateService: TranslateService) {}

  transform(dimensions: any, defaultValue?: string, displayDefaultWhenZeroDimensions?: boolean): string {
    if (!dimensions) {
      return this.translateService.instant(defaultValue);
    }

    if (_.isString(dimensions)) {
      dimensions = JSON.parse(dimensions);
    }

    let height = _.get(dimensions, 'height', '---');
    let width = _.get(dimensions, 'width', '---');
    let length = _.get(dimensions, 'length', '---');

    if (!!displayDefaultWhenZeroDimensions && (!height && !width && !length)) {
      return this.translateService.instant(defaultValue);
    }

    height = height !== '---' ? this.decimalNumberToFix(height) : height;
    width = width !== '---' ? this.decimalNumberToFix(width) : width;
    length = length !== '---' ? this.decimalNumberToFix(length) : length;

    const translatedHeight = this.translateService.instant('DIMENSIONS.H');
    const translatedWidth = this.translateService.instant('DIMENSIONS.W');
    const translatedLength = this.translateService.instant('DIMENSIONS.L');

    return `${height} ${translatedHeight} / ${width} ${translatedWidth} / ${length} ${translatedLength}`;
  }

  private decimalNumberToFix(num: any): string {
    return (num).toFixed(Number.isInteger(num) ? 0 : 2);
  }
}
